import { urlDocumentosPlugin } from 'src/parametros'

const ExpiredPage = () => {
  return (
    <div className="container-fluid" style={{ paddingTop: '10%' }}>
      <div className="row justify-content-center">
        <div className="col-sm-4 align-self-center text-center">
         
        </div>
        <div className=" col-sm-8">
          <p
            style={{
              fontSize: '50px',
              fontWeight: 'bold',
              paddingTop: '20%',
            }}
          >
            Página restringida
          </p>
          <p>
            La url a la que intenta acceder  ya caduco.{' '}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ExpiredPage;
